import { FromSchema, ZodDate } from '@40seas/entities/common';
import { BusinessMatch, BusinessMatchSchema } from '@40seas/entities/match';
import { z } from 'zod';

export const VerifiedBusinessDetailsSchema = z
    .object({
        legalName: z.string().optional(),
        businessStartDate: ZodDate.optional().optional(),
        addresses: z.array(z.string().nullish()).optional(),
        tin: z.string().optional(),
        vat: z.string().optional(),
        website: z.string().optional(),
        phone: z.string().optional(),
        match: BusinessMatchSchema.nullish(),
    })
    .strict();

export class VerifiedBusinessDetails extends FromSchema(VerifiedBusinessDetailsSchema) {
    legalName?: string;
    businessStartDate?: Date;
    addresses?: string[];
    tin?: string;
    vat?: string;
    website?: string;
    phone?: string;
    match?: BusinessMatch;
}
